module.exports = __webpack_public_path__ + "static/img/Testimonial1.4f7d462.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/Testimonial1.png
// module id = RVY9
// module chunks = 0